import React from 'react';
import * as PropTypes from 'prop-types';
import './Layout.css';

const MainSubHeader = ({ children, subClass }) => {
  return (
  <main>
    <div className={"dp-full " + subClass}>
      {children}
    </div>
  </main> );
}

// Validate prop type parameters.
MainSubHeader.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MainSubHeader;
